export enum ELanguage {
	en = 'en',
	ua = 'ua',
	ru = 'ru',
}

export const LANGUAGE_LABEL_MAP: Record<ELanguage, string> = {
	[ELanguage.en]: 'English',
	[ELanguage.ua]: 'Українська',
	[ELanguage.ru]: 'Русский',
}